import { AlertCircleIcon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";

interface WarningBadgeProps {
	label: string;
}

export function WarningBadge({ label }: WarningBadgeProps) {
	return (
		<span className="inline-flex items-center gap-1 rounded-md bg-warning/10 px-2 py-1 font-medium text-warning text-xs">
			<HugeiconsIcon
				icon={AlertCircleIcon}
				strokeWidth={2}
				className="size-3"
			/>
			{label}
		</span>
	);
}
